import actions from './actions'
import mutations from './mutations'
import getters from './getters'
import { Module } from 'vuex'
import { State } from '@/store/store'
import { ScheduleState } from './states'

const AdsAccount: Module<ScheduleState, State> = {
  state: new ScheduleState(),
  actions,
  mutations,
  getters,
  namespaced: true,
}

export default AdsAccount
